import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { EmailTemplatePreview } from 'components/EmailTemplatePreview/EmailTemplatePreview';

import { useLazyGetEmailTemplateDefaultPreviewQuery } from 'api/email-templates-api';

export const HistoryEmailTemplateModal = ({
  visible,
  onClose,
  brand,
  emailType,
  emailTemplateId,
}) => {
  const { t } = useTranslation();
  const [fetchPreview, { data, isFetching }] = useLazyGetEmailTemplateDefaultPreviewQuery();

  useEffect(() => {
    if (visible && emailType) {
      fetchPreview({ type: emailType, brandId: brand?.id, emailTemplateId });
    }
  }, [visible, emailType, brand?.id, emailTemplateId, fetchPreview]);

  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      title={t('historyEmailTemplate.modalTitle')}
      small>
      {visible &&
        (isFetching || !data ? (
          <p className="text-xl text-neutral-5 py-4 text-center">{t('common.loading')}</p>
        ) : (
          <EmailTemplatePreview
            brand={brand}
            className="min-h-[18rem] w-full flex-1 lg:min-h-0"
            subject={data.subject}
            body={data.body}
            showSupportFooter={brand?.include_support_footer ?? true}
            showActions
          />
        ))}
    </AnimatedModal>
  );
};
